// globalStyles.js
import { createGlobalStyle } from 'styled-components';
 
const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: arial, sans-serif;
    font-size:14px;
  }
`;
 
export default GlobalStyle;